export class PagenationModel {
  constructor(
    private pageNum = 1,
    public totalNum = 0,
    public startDispNum = 0,
    public endDispNum = 0
  ) { }

  prevPageNum() {
    return this.pageNum === 1 ? 1 : this.pageNum - 1;
  }

  currentPageNum() {
    return this.pageNum;
  }

  nextPageNum() {
    return this.pageNum + 1;
  }

  btnBackEnabled() {
    return this.pageNum > 1;
  }

  btnNextEnabled() {
    return this.totalNum > this.endDispNum;
  }

}